import styled from "styled-components"

import SVGIcon from "components/modules/common/SVGIcon"

export default function PushConfigCategorySection({ iconName, title, children }) {
  return (
    <Section>
      <CategoryHeader>
        <IconBlock>
          <SVGIcon name={iconName} />
        </IconBlock>
        <Title>{title}</Title>
      </CategoryHeader>
      <ConfigItemBlock>{children}</ConfigItemBlock>
    </Section>
  )
}

const Section = styled.div`
  padding: calc(100vw * (24 / 375)) calc(100vw * (21 / 375));
  & + & {
    border-top: 1px solid #efefef;
  }
`

const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
`

const IconBlock = styled.div`
  width: calc(100vw * (14.32 / 375));
  height: calc(100vw * (14.32 / 375));
`

const Title = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 700;
  line-height: calc(100vw * (20.27 / 375));
  margin-left: calc(100vw * (5.68 / 375));
`

const ConfigItemBlock = styled.div`
  padding-top: calc(100vw * (23 / 375));
`
